<template>
  <div class="side-bar__panel side-bar__panel--menu">
    <menu-entry @click="globalSearch">
      <template #icon><icon-magnify></icon-magnify></template>
      Search in files
      <template #info>⌘⇧F</template>
    </menu-entry>
    <menu-entry @click="keyboardShortcuts">
      <template #icon><icon-help-circle></icon-help-circle></template>
      Keyboard shortcuts
      <template #info>⌘/</template>
    </menu-entry>
    <menu-entry @click="setPanel('backlinks')">
      <template #icon><icon-link-variant></icon-link-variant></template>
      Backlinks
    </menu-entry>
    <menu-entry @click="setPanel('help')">
      <template #icon><icon-help-circle></icon-help-circle></template>
      Markdown cheat sheet
    </menu-entry>
    <hr>
    <menu-entry @click="setPanel('importExport')">
      <template #icon><icon-content-save></icon-content-save></template>
      Import/export
    </menu-entry>
    <menu-entry @click="print">
      <template #icon><icon-printer></icon-printer></template>
      Print
    </menu-entry>
    <hr>
    <menu-entry @click="fileProperties">
      <template #icon><icon-code-tags></icon-code-tags></template>
      File properties
    </menu-entry>
    <menu-entry @click="settings">
      <template #icon><icon-eye></icon-eye></template>
      Settings
    </menu-entry>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import MenuEntry from './common/MenuEntry.vue';
import store from '../../store';

export default {
  components: {
    MenuEntry,
  },
  methods: {
    ...mapActions('data', {
      setPanel: 'setSideBarPanel',
    }),
    async settings() {
      // Close sidebar on mobile before opening modal
      if (window.innerWidth <= 900) {
        store.dispatch('data/toggleSideBar', false);
      }
      try {
        await store.dispatch('modal/open', 'settings');
      } catch (e) {
        // Modal cancelled
      }
    },
    async fileProperties() {
      // Close sidebar on mobile before opening modal
      if (window.innerWidth <= 900) {
        store.dispatch('data/toggleSideBar', false);
      }
      try {
        await store.dispatch('modal/open', 'fileProperties');
      } catch (e) {
        // Modal cancelled
      }
    },
    globalSearch() {
      // Close sidebar before opening global search
      store.dispatch('data/toggleSideBar', false);
      // Dispatch event to open global search
      window.dispatchEvent(new CustomEvent('open-global-search'));
    },
    keyboardShortcuts() {
      // Close sidebar before opening keyboard shortcuts
      store.dispatch('data/toggleSideBar', false);
      window.dispatchEvent(new CustomEvent('open-keyboard-shortcuts'));
    },
    print() {
      const previewContent = document.querySelector('.preview__inner-2');
      if (!previewContent) {
        window.print();
        return;
      }

      // Create hidden iframe for printing
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      iframe.style.left = '-9999px';
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Print</title>
          <style>
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
              font-size: 16px;
              line-height: 1.6;
              color: #333;
              max-width: 800px;
              margin: 0 auto;
              padding: 20px;
            }
            h1, h2, h3, h4, h5, h6 {
              page-break-after: avoid;
              break-after: avoid;
              page-break-inside: avoid;
              break-inside: avoid;
            }
            /* Keep at least 3 lines after heading on same page */
            h1 + *, h2 + *, h3 + *, h4 + *, h5 + *, h6 + * {
              page-break-before: avoid;
              break-before: avoid;
            }
            img, table, pre, blockquote {
              page-break-inside: avoid;
              break-inside: avoid;
            }
            p, li {
              orphans: 3;
              widows: 3;
            }
            pre {
              background: #f5f5f5;
              padding: 10px;
              border-radius: 4px;
              overflow-x: auto;
            }
            code {
              background: #f5f5f5;
              padding: 2px 4px;
              border-radius: 2px;
            }
            blockquote {
              border-left: 4px solid #ddd;
              margin-left: 0;
              padding-left: 20px;
              color: #666;
            }
            table {
              border-collapse: collapse;
              width: 100%;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            img {
              max-width: 100%;
              height: auto;
            }
          </style>
        </head>
        <body>
          ${previewContent.innerHTML}
        </body>
        </html>
      `);
      doc.close();

      let printed = false;
      const doPrint = () => {
        if (printed) return;
        printed = true;
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => iframe.remove(), 1000);
      };

      iframe.contentWindow.onload = doPrint;
      // Fallback if onload doesn't fire
      setTimeout(doPrint, 500);
    },
  },
};
</script>
